import React, {Fragment} from 'react';
import Tabs from 'react-responsive-tabs';
import CloudApiSettings from "../../CloudApi";
import InboxSettings from "./InboxSettings";
import OptInOutManagement from "./OptInOutManagement";
import { useForm } from "react-hook-form";
import { getAppType } from '../../../Common/Appcommon';

function GetTabsContent () {
    const form = useForm();
    const appType = getAppType();
    const tabsContent = [
        {
            title: 'API Settings',
            content: <CloudApiSettings/>,
            groupname : 'wa_settings'
        },
        {
            title: 'Inbox Settings',
            content: <InboxSettings/>,
            groupname : 'wa_settings'
        },
        {
            title: 'Opt-in Management',
            content: <OptInOutManagement useForm={form}/>,
            groupname : 'wa_settings'
        }
    ];
    let modifiedTabs = tabsContent;
    if(appType === '0') {
        modifiedTabs = [];
        tabsContent.map((tab, index) => {
            if(tab.groupname !== "legacy"){
                modifiedTabs.push(tab);
            }
        })
    }
    return modifiedTabs;
}
function getTabs() {
    let tabsContent = GetTabsContent();
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}

const WhatsappSettings = props => {

    return (
        <Fragment>
            <Tabs tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding" transform={false} showInkBar={true} items={getTabs()}/>
        </Fragment>
    )


}

export default WhatsappSettings;
